import styled from 'styled-components'

export const LinkContainer = styled.a<{ color: string }>`
  color: ${(props) => props.color};
  text-decoration: none;
`
